import React, { useState } from "react";
import { Button, Col, Container, Dropdown, Form, Row } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import { Link } from "react-router-dom";
import { CstmPagination } from "../../../components/Common/Common";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import dataHandler from "../../../hooks/dataHandler";
import {
  DELETESERVICECATEGORY,
  HOTELADMIN,
  HOTELADMINBLOCKUNBLOC,
  HOTELADMINDELETE,
} from "../../../services/ApiCalls";
import CustomPagination from "../../../components/Common/CustomPagination";
import TableActions from "../../../components/Common/TableActions";
import moment from "moment";
import Filter from "../../../components/Common/Filter";
import { activeInactiveOptions, csvImportEnum } from "../../../utilities/const";
import {
  exportCsvHandler,
  removeUnderScoreAndCapitalizeFirstLetter,
} from "../../../utilities/utilities";
import Toggle from "../../../components/Common/Toggle";
import ImportCsv from "../../../components/Common/ImportCsv";
import ButtonLoader from "../../../components/Common/ButtonLoader";
import CountryFilter from "../../../components/Common/CountryFilter";
import { useTranslation } from "react-i18next";

const ManageHotelAdmin = () => {
  const [exportLoader, setExportLoader] = useState(false);
  const { t } = useTranslation();

  const {
    setBody,
    body,
    data,
    statusChangeHandler,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: HOTELADMIN,
  });

  const columns = [
    {
      head: t("manageHotelAdmin.columns.serialNumber"),
      accessor: "#",
      component: (item, key) => {
        return <>{body.limit * (body.page - 1) + key + 1}</>;
      },
    },
    {
      head: t("manageHotelAdmin.columns.name"),
      accessor: "name",
      component: (item) => (
        <>
          {item.name
            ? item.name
            : t("manageHotelAdmin.placeholders.notAvailable")}
        </>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.address"),
      accessor: "address",
      component: (item) => {
        const words = item?.address?.split(" ");
        const truncatedText = words?.slice(0, 4).join(" ");
        const displayText =
          words?.length > 1
            ? `${truncatedText}...`
            : truncatedText || t("manageHotelAdmin.placeholders.notAvailable");
        return <span title={item?.address}>{displayText}</span>;
      },
    },
    {
      head: t("manageHotelAdmin.columns.mobileNumber"),
      accessor: "mobileNumber",
      component: (item) => (
        <span className="text-nowrap">
          {item?.countryCode}{" "}
          {item?.mobileNumber ||
            t("manageHotelAdmin.placeholders.notAvailable")}
        </span>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.email"),
      accessor: "email",
      component: (item) => (
        <span className="text-wrap">
          {item?.email
            ? item.email
            : t("manageHotelAdmin.placeholders.notAvailable")}
        </span>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.avgRating"),
      accessor: "avgRating",
      component: (item) => (
        <span className="px-2">
          {item?.avgRating
            ? item.avgRating
            : t("manageHotelAdmin.placeholders.zero")}
        </span>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.accountCreatedAt"),
      accessor: "createdAt",
      component: (item) => (
        <>
          {item.createdAt
            ? moment(item.createdAt).format("MM-DD-YYYY , HH:mm")
            : t("manageHotelAdmin.placeholders.notAvailable")}
        </>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.numberOfHotels"),
      accessor: "totalHotels",
      component: (item) => (
        <>
          {item?.totalHotels
            ? item.totalHotels
            : t("manageHotelAdmin.placeholders.zero")}
        </>
      ),
    },
    {
      head: t("manageHotelAdmin.columns.changeStatus","Block/Unblock"),
      accessor: "status",
      title: t("manageHotelAdmin.statusTooltip"),
      component: (item, key) => (
        <Toggle
          isChecked={item.status === "Active"}
          onChange={() =>
            statusChangeHandler(
              () =>
                HOTELADMINBLOCKUNBLOC({
                  id: item._id,
                  status: item.status === "Active" ? "Blocked" : "Active",
                }),
              key
            )
          }
        />
      ),
    },
    {
      head: t("manageHotelAdmin.columns.action"),
      accessor: "action",
      component: (item) => (
        <TableActions
          viewLink={`/manage-hotel-admin/detail/${item._id}`}
          editUrl={`/manage-hotel-admin/edit/${item._id}`}
          setDeleteModel={() =>
            setDeleteModel({ show: true, dumpId: item._id })
          }
        />
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        type={"delete"}
        confirmation={deleteModel.show}
        setConfirmation={() =>
          setDeleteModel({
            show: false,
            dumpId: "",
          })
        }
        confirmHandler={() =>
          deleteHandler(() =>
            DELETESERVICECATEGORY({ _id: deleteModel.dumpId })
          )
        }
      />
      <ConfirmationPop
        confirmation={deleteModel.show}
        setConfirmation={() => setDeleteModel({ show: false, dumpId: "" })}
        type={"delete"}
        confirmHandler={() =>
          deleteHandler(() => HOTELADMINDELETE({ _id: deleteModel.dumpId }))
        }
      />
      <section className="manageServiceCategory py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between align-items-center">
                <h4 className="mb-0 py-3 fw-bold text-dark text-capitalize">
                  {t("manageHotelAdmin.title")}
                </h4>

                <div className="d-flex align-items-center gap-2">
                  <label
                    htmlFor="countryFilter"
                    className="form-label m-0 fw-semibold text-muted"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {t("manageHotelAdmin.filter")}
                  </label>
                  <CountryFilter
                    id="countryFilter"
                    body={body}
                    setBody={setBody}
                  />
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="tableFilter d-flex align-items-center justify-content-between flex-wrap gap-10 mb-3">
                <div className="left">
                  <Filter
                    body={body}
                    searchHandler={searchHandler}
                    setBody={setBody}
                    statusFilterOptionArr={activeInactiveOptions}
                  />
                </div>

                <div className="right">
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                    {/* <li className="">
                      <ImportCsv
                        item={csvImportEnum.hotelAdmins}
                        callBack={() => refetch()}
                      />
                    </li> */}
                    <li className="">
                      <Button
                        className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                        type="button"
                        onClick={() =>
                          exportCsvHandler("hoteladmin", setExportLoader)
                        }
                      >
                        {exportLoader ? (
                          <ButtonLoader />
                        ) : (
                          t("manageHotelAdmin.buttons.exportCsv")
                        )}
                      </Button>
                    </li>
                    <li className="">
                      <Link
                        to="/manage-hotel-admin/add"
                        className="d-flex btn btn-primary align-items-center justify-content-center fw-sbold commonBtn "
                        style={{ height: 40, minWidth: 100, fontSize: 12 }}
                      >
                        {t("manageHotelAdmin.buttons.addNewHotelAdmin")}
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <TableLayout column={columns} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={paginationHandler}
                body={body}
                setBody={setBody}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageHotelAdmin;
